module.exports = __webpack_public_path__ + "assets/img/trait1.68974bc6.png";